import { useState } from "react";
import React from "react";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import { ThemeProvider } from "./themeContext";

const Admin = ({ children }) => {
	const [collapseShow, setCollapseShow] = useState(true);
	const [profileShow, setProfileShow] = useState(true);

	return (
		<>
			<ThemeProvider>
				<div className="flex h-screen bg-gray-50 dark:bg-gray-900">
					<Sidebar
						collapseShow={collapseShow}
						setCollapseShow={setCollapseShow}
					/>
					{/* min-w-0 here and grid-cols-1 below keep a wide chart or table from
					    pushing the page past the window: a chart drawn wide on a larger
					    window could not shrink back when the window got narrower */}
					<div className="flex flex-col flex-1 w-full min-w-0">
						<Navbar
							collapseShow={collapseShow}
							setCollapseShow={setCollapseShow}
							profileShow={profileShow}
							setProfileShow={setProfileShow}
						/>
						<main className="h-full overflow-y-auto">
							<div className="container grid grid-cols-1 px-6 mx-auto">{children}</div>
						</main>
					</div>
				</div>
			</ThemeProvider>
		</>
	);
};

export default Admin;
